import React from 'react';
import {C} from '../registries/compatibilty';

export const useAuthorHeightCalc = (height: number): string | undefined =>
    React.useMemo(
        () =>
            C.isInEditor()
                ? window.parent.innerHeight * height + 'px'
                : undefined,
        [height]
    );
